import React from "react";
import { ChevronDown } from "lucide-react";
import { FaCheck } from "react-icons/fa6";

// Static Mobile Apps data
const mobileApps = [
  {
    key: "company",
    title: "Company App",
    description: "HRMS & Workforce Management",
    features: [
      "Employer & Admin Mobile App",
      "Employee Management",
      "Attendance Monitoring",
      "Leave & Request Approvals",
      "Payroll Access",
      "Reports & Notifications",
    ],
  },
  {
    key: "employee",
    title: "Employee App",
    description: "Employee Self-Service (ESS)",
    features: [
      "Employee Self-Service App",
      "Mobile Attendance",
      "Selfie & GPS Attendance",
      "Leave Management",
      "Payslip Access",
      "Expense & Overtime Requests",
      "Loan & Advance Requests",
      "Company Announcements",
    ],
  },
  {
    key: "facelens",
    title: "FaceLens App",
    description: "Face Recognition & Biometric Attendance Solution",
    features: [
      "Face Recognition Attendance",
      "Contactless Attendance",
      "Mobile as Biometric Machine",
      "Employee Face Verification",
      "Check-In & Check-Out",
      "Real-Time Attendance Sync",
      "No Biometric Hardware Required",
    ],
  },
];

// Tick component
const Tick2 = () => (
  <span
    className="
      flex h-6 w-6 shrink-0 items-center justify-center
      rounded-md
      border border-[#c9dce9]
      bg-[#f5f9fd]
      text-[#10324F]
      shadow-[0_2px_6px_rgba(16,50,79,0.12)]
    "
  >
    ✓
  </span>
);

function Tick() {
  return (
    <span
      className="inline-flex items-center justify-center w-6 h-6 rounded-md border border-[#D1DFEA] backdrop-blur-[15px]
      shadow-[0px_0px_4px_0px_#D1DFEA6B,-3px_-3px_7px_0px_#D1DFEA_inset]"
    >
      <FaCheck className="text-xs text-[#10324F]" />
    </span>
  );
}

const accordionHeaderClass = `list-none  cursor-pointer  w-full bg-[linear-gradient(180deg,rgba(209,223,234,0.104)_50.18%,rgba(209,223,234,0.4)_100%)] shadow-[-3px_-3px_10px_0px_#D1DFEA_inset] px-3 sm:px-6 py-3 flex items-center justify-between`;

const MobileAppsSection = () => {
  return (
    <>
      <div className="hidden md:block">
        <details
          open
          className="group bg-[#10324F] border border-[#d9e7f3] rounded-xl overflow-hidden mt-20"
        >
          {/* Main Mobile Apps heading  */}
          <summary className="list-none cursor-pointer w-full bg-[linear-gradient(180deg,rgba(209,223,234,0.104)_50.18%,rgba(209,223,234,0.4)_100%)] shadow-[-3px_-3px_10px_0px_#2a5373_inset] px-6 py-3 flex items-center justify-between">
            <span className="font-roboto font-medium text-white text-base leading-normal">
              Mobile Apps
            </span>

            <ChevronDown
              size={18}
              className="
        text-white
        transition-transform
        group-open:rotate-180
      "
            />
          </summary>

          {/* 3 App List */}
          <div className="bg-[#f5f9fd]">
            {mobileApps.map((app, index) => (
              <details
                key={app.title}
                open={index === 0}
                className="group/app border-0"
              >
                {/* App heading */}
                <summary className={accordionHeaderClass}>
                  <div className="flex flex-wrap items-center gap-x-1 gap-y-0.5 min-w-0">
                    <span className="font-roboto font-medium text-[#10324F] text-base leading-normal">
                      {app.title}
                    </span>

                    {app.description && (
                      <span className="font-roboto text-[#10324F] text-xs font-normal">
                        - {app.description}
                      </span>
                    )}
                  </div>

                  <ChevronDown
                    size={17}
                    className="
              text-[#10324F]
              transition-transform
              group-open/app:rotate-180
            "
                  />
                </summary>

                {/* Features */}
                <div className="bg-white">
                  {app.features.map((feature) => (
                    <div
                      key={feature}
                      className="
                grid
                grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr]
                border-b
                border-[#edf3f8]
                min-h-14
              "
                    >
                      {/* Feature name */}
                      <div
                        className="
                  flex col-span-2
                  items-center
                  px-4
                  text-[#10324F]
                  text-xs
                  leading-4
                  border-r
                  border-[#edf3f8]
                "
                      >
                        {feature}
                      </div>

                      {/* Tick 1 */}
                      <div className="p-4 flex items-center justify-center border-r last:border-r-0 border-[#edf3f8] bg-white/40">
                        <Tick />
                      </div>

                      {/* Tick 2 */}
                      <div className="p-4 flex items-center justify-center border-r last:border-r-0 border-[#edf3f8] bg-white/40">
                        <Tick />
                      </div>

                      {/* Tick 3 */}
                      <div className="p-4 flex items-center justify-center border-r last:border-r-0 border-[#edf3f8] bg-white/40">
                        <Tick />
                      </div>

                      {/* Tick 4 */}
                      <div className="p-4 flex items-center justify-center border-r last:border-r-0 border-[#edf3f8] bg-white/40">
                        <Tick />
                      </div>

                      {/* Tick 5 */}
                      <div className="flex items-center justify-center">
                        <Tick />
                      </div>
                    </div>
                  ))}
                </div>
              </details>
            ))}
          </div>
        </details>
      </div>
      <div className="block md:hidden mt-8">
        <details
          open
          className="group bg-[#10324F] border border-[#d9e7f3] rounded-xl overflow-hidden"
        >
          {/* Mobile Apps heading */}
          <summary className="list-none cursor-pointer w-full bg-[linear-gradient(180deg,rgba(209,223,234,0.104)_50.18%,rgba(209,223,234,0.4)_100%)] shadow-[-3px_-3px_10px_0px_#2a5373_inset] px-3 py-3 flex items-center justify-between">
            <span className="font-roboto font-medium text-white text-base leading-normal">
              Mobile Apps
            </span>

            <ChevronDown
              size={17}
              className="
          text-white
          transition-transform
          group-open:rotate-180
        "
            />
          </summary>

          {/* Apps */}
          <div className="bg-[#f5f9fd]">
            {mobileApps.map((app, index) => (
              <details
                key={app.title}
                open={index === 0}
                className="group/mobile border-0"
              >
                {/* App heading */}
                <summary className={accordionHeaderClass}>
                  <div className="flex flex-wrap items-center gap-x-1 gap-y-0.5 min-w-0">
                    <span className="font-roboto font-medium text-[#10324F] text-xs leading-normal">
                      {app.title}
                    </span>

                    {app.description && (
                      <span className="font-roboto text-[#10324F] text-xs font-normal">
                        - {app.description}
                      </span>
                    )}
                  </div>
                  <ChevronDown
                    size={16}
                    className="
                text-[#10324F]
                transition-transform
                group-open/mobile:rotate-180
              "
                  />
                </summary>

                {/* Features */}
                <div className="bg-white">
                  {app.features.map((feature) => (
                    <div
                      key={feature}
                      className="
                  grid
                  grid-cols-[1fr_45px]
                  min-h-10
                "
                    >
                      {/* Feature */}
                      <div
                        className="
                    flex
                    items-center
                    px-4
                    py-2
                    text-[#10324F]
                    text-[11px]
                    leading-4
                  "
                      >
                        {feature}
                      </div>

                      {/* Tick */}
                      <div
                        className="
                    flex
                    items-center
                    justify-center
                    bg-white/40
                  "
                      >
                        <Tick />
                      </div>
                    </div>
                  ))}
                </div>
              </details>
            ))}
          </div>
        </details>
      </div>
    </>
  );
};

export default MobileAppsSection;
